{
  "browserNotSupported": {
    "title": "Le module n’a pas pu être chargé",
    "text": "Pour pouvoir utiliser le navigateur de pièces, veuillez opter pour un navigateur actuel ."
  },
  "main": {
    "more": "Autres accessoires",
    "findMore": "Vous pouvez trouver ici des accessoires pour la mise à niveau/la transformation et la mise à niveau de votre véhicule dans notre vaste gamme. Les accessoires que vous avez sélectionnés seront envoyés à votre partenaire {{brand}} avec la demande de véhicule.",
    "topOffers": "MEILLEURES offres",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Produits",
    "noArticleFound": "0 Produits",
    "oemHint": "Choisissez maintenant les accessoires assortis à votre {{brand}} !",
    "noBrand": "Sélectionnez dès maintenant les accessoires adaptés à votre véhicule !",
    "outOfOrder": "Malheureusement, aucun produit n'est disponible pour le moment.<0/>Nous sommes en train de mettre à jour notre catalogue.<0/>N'hésitez pas à revenir nous voir ultérieurement.",
    "nextSlide": "Suivant",
    "prevSlide": "Précédent"
  },
  "cart": {
    "add": "Produit ajouté au véhicule",
    "fullPrice": "Prix véhicule et accessoires",
    "priceWithoutCar": "Prix accessoires"
  },
  "navigation": {
    "zoom": "Zoom",
    "toggleSearch": "Basculer la recherche",
    "cart": "Panier",
    "cartDelete": "Supprimer l'article du panier",
    "vehicle": "Véhicule sélectionné",
    "maxBookmarksReached": "Maximum de 15 produits atteints",
    "filter": {
      "toggleFilter": "Basculer le filtre",
      "topProducts": "MEILLEURES offres",
      "reset": "Réinitialiser le filtre",
      "ready": "Terminé",
      "show": "Afficher les résultats"
    },
    "searching": {
      "submit": "Soumettre",
      "close": "Fermer",
      "placeholder": "Rechercher les accessoires assortis ...",
      "suggestions": "Suggestions de recherche",
      "categories": "Catégories",
      "products": "Produits",
      "productCount": "{{count}} produit",
      "productCount_other": "{{count}} produits",
      "showAll": "Afficher {{count}} résultat",
      "showAll_other": "Afficher les {{count}} résultats",
      "expand": "Recherche étendue",
      "show": "Afficher les résultats",
      "found": {
        "withCategory": "Résultats de la recherche pour «{{fuzzy}}» dans la catégorie «{{category}}»",
        "withOutCategory": "Résultats de la recherche pour «{{fuzzy}}» dans toutes les catégories"
      }
    },
    "share": "Partage",
    "back": "Retour",
    "details": "Détails",
    "add": "Ajouter",
    "remove": "Supprimer",
    "close": "Fermer",
    "filtern": "Filtrer",
    "closeFilter": "Fermer le filtre"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Aller à l'image {{number}}"
    },
    "articleNumber": "Référence article",
    "relatedArticle": "Ces articles pourraient également vous intéresser :",
    "brand": "Marque",
    "priceBox": {
      "withVatAndMounting": "incl. TVA & montage",
      "withVat": "TVA incluse.",
      "recommendedRetailPrice": "Prix initial",
      "historicMinimalPurchasePrice": "Prix le plus bas des 30 derniers jours",
      "priceDetails": "Détails du prix",
      "priceDetailsHeadline": "Détails du prix pour cet article",
      "priceToday": "Prix pour cet article aujourd'hui",
      "priceDetails30Days": "Prix le plus bas au cours des 30 jours précédant le changement de prix",
      "close": "Fermer",
      "addItem": "Ajouter cet article",
      "removeItem": "Supprimer cet article"
    },
    "infoBox": {
      "description": "Description",
      "vehicles": "Convient aux modèles suivants",
      "empty": "Il n'y a pas d'attribution de véhicule spécifique pour ce produit.",
      "contacts": "Fabricant"
    },
    "contacts": {
      "manufacturer-contact": "Informations de contact du fabricant",
      "responsible-contact": "Personne responsable dans l'UE",
      "trademark": "Marque"
    }
  },
  "productList": {
    "oemHint": "Accessoires originaux pour votre {{brand}}"
  }
}
